//Libs
import styled from "styled-components";
import { TimePicker as _TimePicker } from "antd";

const TimePicker = styled(_TimePicker)`
  width: ${(props) => props.width || props.theme.timePicker.width};
`;

export default TimePicker;
